import React, { useRef, useState } from "react";
import { Form, Input, Spin, Modal, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { saveFile, uploadFile } from "../../../features/save/saveSlice";
import Dragger from "antd/es/upload/Dragger";

const MonthlyImageAdd = ({ isModalOpen, handleCancel, onAdd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();

  const [fileUrl, setFileUrl] = useState("");
  const [fileLoading, setFileLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  const resetFile = () => {
    setFileList([]);
    setFileUrl("");
  };

  const handleClose = () => {
    resetFile();
    form.resetFields();
    handleCancel();
  };

  const props = {
    name: "file",
    multiple: false,
    accept: "image/*",
    showUploadList: true,
    fileList,

    beforeUpload: async (file) => {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        toast.error("Only image files are allowed.");
        return false;
      }

      setFileLoading(true);
      setFileList([{ uid: file.uid, name: file.name, status: "uploading" }]);

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await dispatch(saveFile(formData)).unwrap();
        if (res?.success) {
          toast.success(`${file.name} uploaded successfully.`);
          setFileUrl(res?.targetUrl);
          setFileList([{ uid: file.uid, name: file.name, status: "done" }]);
        } else {
          message.error(`Upload failed: ${res.message}`);
          resetFile();
        }
      } catch (err) {
        message.error("Upload failed");
        resetFile();
      } finally {
        setFileLoading(false);
      }

      return false;
    },

    onRemove: () => resetFile(),
    onDrop: () => setFileLoading(false),
  };

  const onFinish = (data) => {
    if (!fileUrl) {
      toast.error("Please upload an image");
      return;
    }
    onAdd({ attDesc: data.mriFileName, attFile: fileUrl });
    handleClose();
  };

  return (
    <Modal
      title="Add Image"
      open={isModalOpen}
      onCancel={handleClose}
      className="!w-[59.5rem]"
      maskClosable={false}
      footer={null}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="monthly-image-add"
        onFinish={onFinish}
        form={form}
        style={{ maxWidth: "100%" }}
      >
        <Form.Item
          name="mriFileName"
          label="Image Name"
          rules={[{ required: true, message: "Please add image name" }]}
        >
          <Input className="input" />
        </Form.Item>

        <Form.Item name="attFile" label="Image File">
          <Dragger className="attachment" {...props}>
            <div className="flex flex-col justify-center">
              <div className="flex justify-center mb-5">
                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                  <path d="M25.375 18.125V22.9583C25.375 23.5993 25.1204 24.214 24.6672 24.6672C24.214 25.1204 23.5993 25.375 22.9583 25.375H6.04167C5.40073 25.375 4.78604 25.1204 4.33283 24.6672C3.87961 24.214 3.625 23.5993 3.625 22.9583V18.125" stroke="#147CBC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M20.5423 9.66667L14.5007 3.625L8.45898 9.66667" stroke="#147CBC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M14.5 3.625V18.125" stroke="#147CBC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <p className="ant-upload-text !ml-2">
                Click to upload
                <span className="ml-2 text-[#667085]">or drag and drop</span>
                <br />
                <span className="text-[#667085]">PNG or JPG (max. 800x400px)</span>
              </p>
            </div>
          </Dragger>
        </Form.Item>

        <div className="flex justify-end mb-[2rem] gap-x-5">
          <div className="w-[150px]">
            <button type="button" onClick={handleClose} className="cstm-btn">
              Cancel
            </button>
          </div>
          <div className="w-[150px]">
            <button disabled={fileLoading} type="submit" className="cstm-btn-2">
              {fileLoading ? <Spin /> : "Add"}
            </button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default MonthlyImageAdd;
